import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  SET_UPDATES_LOADING,
  UPDATE_FILTER,
  FETCH_METRICS,
  SET_DATES,
  UPDATES_DATES,
  SET_FILTERS_DIRTY,
  RESET_FILTERS_SUCCESS
} from "./leadStatusSagas";

const firstBooking = [
  { id: "visit_date", name: "Booking Date" },
  { id: "booking_date", name: "Log Date" }
];
const firstVisit = [
  { id: "visit_date", name: "Visit Date" },
  { id: "booking_date", name: "Log Date" }
];
const firstEnrollment = [
  { id: "sale_date", name: "Sale Date" },
  { id: "invoice_date", name: "Invoice Added Date" }
];

const initialState = {
  isLoading: true,
  filtersDirty: false,
  isUpdating: false,
  initialRequest: false,
  currentUser: {},
  filters: {
    firstBooking,
    firstVisit,
    firstEnrollment
  },
  metrics: [],
  selectedFilters: {
    dates: {},
    firstBooking: firstBooking[0],
    firstVisit: firstVisit[0],
    firstEnrollment: firstEnrollment[0]
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      isUpdating: action.payload,
      filtersDirty: false
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        dates: action.payload
      }
    }),
    [UPDATES_DATES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        dates: action.payload
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      initialRequest: true,
      currentUser: action.payload
    }),
    [FETCH_METRICS]: (state, { payload }) => ({
      ...state,
      metrics: payload
    }),
    [UPDATE_FILTER]: (state, { payload: { key, data } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        [key]: data
      }
    }),
    [RESET_FILTERS_SUCCESS]: (state) => ({
      ...state,
      selectedFilters: initialState.selectedFilters
    })
  },
  initialState
);
